import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../../../config/AuthContext';
import Login from '../../Login';
import { Content } from 'antd/es/layout/layout';
import AppSiderPildoresId from './menus/AppSiderPildoresId';
import PildoresIdPildores from './content/PildoresIdPildores';
import PildoresIdEstadistiques from './content/PildoresIdEstadistiques';

const PildoresId = ({ page }: { page: number }) => {
    const { isLoggedIn, user } = useContext(AuthContext);
    const { id_conjunt } = useParams();
    const navigate = useNavigate();
    const [pantalla, setPantalla] = useState(page);

    useEffect(() => {
        setPantalla(page);
    }, [id_conjunt, page]);

    if (!isLoggedIn) return <Login />;

    return (
        <>
            <AppSiderPildoresId setPantalla={setPantalla} initialPantalla={page || 0} />
            <Content style={{ padding: '0 24px', minHeight: 280 }}>
                {pantalla === 0 && <PildoresIdPildores />}
                {pantalla === 1 && <PildoresIdEstadistiques />}
            </Content>
        </>
    );
};

export default PildoresId;
